import { formatNumber } from '@progress/kendo-intl';
import { useCallback } from 'react';
import { api } from 'src/constants/apiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

export interface InvoiceGlBudgetSummaryResponse {
  glPeriodId?: number;
  glCdId?: number;
  remainingBudget?: number | null | undefined;
  remainingInitialBudget?: number | null | undefined;
  id?: number;
  value?: string;
}

const useInvoiceGlBudgetSummaryApi = (invoiceId: string) => {
  const call = useCallback(
    () =>
      new Promise<InvoiceGlBudgetSummaryResponse[]>((resolve, reject) => {
        axiosInstance
          .get<InvoiceGlBudgetSummaryResponse[]>(api.getInvoiceGlBudgetSummary(invoiceId))
          .then((res) => {
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      }),
    [invoiceId]
  );
  const { isLoading, value, setValue, execute } = useAsync(call, true);
  return {
    invoiceGlBudgetSummary: value,
    setInvoiceGlBudgetSummary: setValue,
    getInvoiceGlBudgetSummary: execute,
    isLoading,
  };
};

export default useInvoiceGlBudgetSummaryApi;

export const generateGlCodeLabel = (label: string, glBudget: any, usesInitialBudgets?: boolean) => {
  const forecastBalance = formatNumber(
    Number((glBudget?.remainingBudget || glBudget?.balance) ?? 0),
    'c2'
  );
  if (usesInitialBudgets) {
    const budgetBalance =
      glBudget?.remainingInitialBudget != null || glBudget?.initialBudgetBalance != null
        ? formatNumber(
            Number(glBudget?.remainingInitialBudget || glBudget?.initialBudgetBalance),
            'c2'
          )
        : 'N/A';
    return !label?.length
      ? ''
      : `${label}.\nBudget Balance: ${budgetBalance}\nForecast Balance: ${forecastBalance}`;
  }
  return !label?.length ? '' : `${label}\nForecast Balance: ${forecastBalance}`;
};
